// extracted by mini-css-extract-plugin
export default {"ForgotPasswordForm":"Yw8my","text":"WSgTU","error":"TsnV-","button":"lckWf","confirmPassword":"DDzz-","letterSpam":"bWLcy","skeleton-progress":"uDm0Q"};